/**
 * useMyPayslips — saját bérjegyzék lista lekérése (PAY-10 self-service)
 *
 * GET /api/v1/payroll/payslip/my?year=...
 * RBAC: OPERATOR, TECHNIKUS, BOLTVEZETO, PARTNER_OWNER, SUPER_ADMIN
 */

import { api } from '@/api/client';
import { useQuery } from '@tanstack/react-query';

export interface MyPayslipRow {
  id: string;
  payrollRunId: string;
  employeeProfileId: string;
  baseSalary: number;
  totalGross: number;
  personalIncomeTax: number;
  employeeSocialTax: number;
  totalDeductions: number;
  totalNet: number;
  workingDays: number;
  workedDays: number;
  createdAt: string;
  updatedAt: string;
}

interface MyPayslipsResponse {
  data: MyPayslipRow[];
}

export function useMyPayslips(year: number) {
  return useQuery<MyPayslipRow[]>({
    queryKey: ['payroll', 'my-payslips', year],
    queryFn: async () => {
      const res = await api.get<MyPayslipsResponse>(`/payroll/payslip/my?year=${year}`);
      return res.data;
    },
    staleTime: 60_000,
  });
}
